module.exports = __webpack_public_path__ + "assets/img/13.6a77b57c.png";